<template>
    <ul>
        <li> <router-link to="/help/other/background">背景を設定する</router-link> </li>
        <li> <router-link to="/help/other/news">一言</router-link> </li>
        <li> <router-link to="/help/other/wall">壁打ち</router-link> </li>
        <li> <router-link to="/help/other/share">貸し本棚を宣伝する</router-link> </li>
        <li> <router-link to="/help/other/limits">制限値</router-link> </li>
        <li> <router-link to="/help/other/api">API</router-link> </li>
    </ul>
</template>